import script from "./Pesquisa.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pesquisa.vue?vue&type=script&setup=true&lang=ts"

import "./Pesquisa.vue?vue&type=style&index=0&id=2e986ef7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e986ef7"]])

export default __exports__